import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { BeaconSubtitleContainer } from 'src/components/BeaconV2Components/BeaconChartWithLegend/BeaconSubtitleContainer';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';
import {
  useEntityPhrasing,
  useTaxonomySubtitleText
} from 'src/components/BeaconV2Components/common/BeaconProDynamicSubtitle/hooks';
import { useComparisonTimePeriodShortDisplayName } from 'src/utils/Hooks';
import { useMainTimePeriodShortDisplayName } from 'src/utils/Hooks';
import SubtitleFilters from 'src/components/Charts/SubtitleFilters';
import { calculatePercentChange, formatMetric } from 'src/utils/app';
import { titleCase } from 'src/utils/stringFormatting';
import SplineChartLoading from 'src/components/BeaconV2Components/SplineChartLoading/SplineChartLoading';
import { ENTITY_PHRASES } from 'src/utils/constants';
import { CHART_NAMES } from 'src/utils/chartContext/chartContextRegistry';

const AtlasV2TotalTrafficV2TotalTrafficSplineChart = () => {
  const entityPhrase = useEntityPhrasing();
  const taxonomyText = useTaxonomySubtitleText();
  const mainTimePeriodShortDisplayName = useMainTimePeriodShortDisplayName();
  const comparisonTimePeriodShortDisplayName = useComparisonTimePeriodShortDisplayName();

  return (
    <AtlasV2DorisSplineChart
      queryKey="totalTrafficSplineChart"
      title="Total Traffic"
      metricTypeDisplay={METRICTYPE.VOLUME}
      metricType="totalClicks"
      splineChartProps={{ chartContextId: CHART_NAMES.TOTAL_TRAFFIC_SPLINE }}
      beaconChartWithLegendOverride={(props, metric) => {
        const { formattedPercentChange, primaryTotal, secondaryTotal } = metric;

        const formattedClicks = formatMetric(primaryTotal, METRICTYPE.VOLUME, {
          showFullValue: false,
          decimalPlaces: 1
        });
        const percentChange = calculatePercentChange(primaryTotal, secondaryTotal);
        const percentDirection = percentChange >= 0 ? 'higher' : 'lower';

        return {
          ...props,
          includeSummaryInfo: false,
          loadingComponent: <SplineChartLoading includeSubtitle />,
          subtitle: (
            <BeaconSubtitleContainer>
              <Text variant="body1" lineHeight="24px">
                {`${titleCase(entityPhrase, [...ENTITY_PHRASES])} earned ${formattedClicks} total traffic `}
                {taxonomyText}
                {` during the ${mainTimePeriodShortDisplayName} period, which is ${formattedPercentChange} ${percentDirection} compared to the ${comparisonTimePeriodShortDisplayName}.`}
                <SubtitleFilters showFilterNumber={false} />
              </Text>
            </BeaconSubtitleContainer>
          )
        };
      }}
    />
  );
};
export default AtlasV2TotalTrafficV2TotalTrafficSplineChart;
